import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as extract from 'extractFromState';
import * as actions from 'actions/CommerceWizardActions';
import * as paths from 'constants/commerceWizardPathOptions';
import * as listTypes from 'constants/infoPanelTypes';
import { DecisionTreeButton } from 'components/common/buttonsComponents';
import CWProduct from '../CWProduct/CWProduct';
import isEmpty from 'lodash/isEmpty';
import { SelectOptionsWrapper, HeaderWrapper, ButtonWrapper } from './CWHomepage.styles';

const CWHomePage = (props) => {
  const isDataAvailable = () => {
    const { upSellProducts, crossSellProducts, globalProducts } = props;

    // TO DO: This is a temporary hack. Change when more options are available
    return !isEmpty(upSellProducts) || !isEmpty(crossSellProducts) || !isEmpty(globalProducts);
  };

  // TODO: Fix dependency array
  useEffect(() => {
    const availableOptions = paths.HOME_PATH_OPTIONS.filter((path) => {
      return isDataAvailable();
    });

    // autoselect if only one option is available
    if (availableOptions.length === 1) {
      props.setCommerceWizardPath(availableOptions);
    }
  }, []); // eslint-disable-line

  const getProductPrice = (product) => {
    return product.price && Math.floor(product.price).toFixed(0);
  };

  const getLabel = (path) => {
    switch (path) {
      case paths.CROSS_SELL_PRODUCTS:
        return 'Product Suggestion';
      default:
        return null;
    }
  };

  const showWizard = () => {
    return props.listType === listTypes.COMMERCE;
  };

  // this is temporary - we will show both simultaneously soon
  return showWizard() ? (
    <>
      <HeaderWrapper>
        <h1>There are some additional ways you can connect with this customer!</h1>
        <div>
          <p>&rarr; You can suggest products the customer might like</p>
          <p>&rarr; You can relate to events in the customer's life</p>
          <p>&rarr; You can lend the customer additional assistance</p>
          <img src={'/images/commerce-wizard-graphic.svg'} alt="graphic" />
        </div>
      </HeaderWrapper>
      <SelectOptionsWrapper>
        <p>Based on the conversation, these are topics you should explore with the customer</p>
        <ButtonWrapper>
          {paths.HOME_PATH_OPTIONS.map((path) => {
            return (
              isDataAvailable(path) && (
                <DecisionTreeButton key={path} onClick={() => props.setCommerceWizardPath([path])}>
                  {getLabel(path)}
                </DecisionTreeButton>
              )
            );
          })}
        </ButtonWrapper>
      </SelectOptionsWrapper>
      {/* <S.SelectProductWrapper>
        {props.previouslyReceommendedProducts.slice(0, 3).map((product, idx) => (
          <S.SelectProduct key={`previous_${idx}`} onClick={() => props.setCommerceWizardPreviousRecommendation(product)}>
            <S.SelectProductImage url={product.image} />
            <div>
              <h3>${getProductPrice(product)}</h3>
              <h4>See details</h4>
            </div>
          </S.SelectProduct>
        ))}
      </S.SelectProductWrapper> */}
    </>
  ) : (
    <>
      {props.previouslyRecommendedProducts.map((product) => (
        <CWProduct
          key={product.title}
          tooltipText={'These are products other Simplr agents have already recommended to the customer'}
          headerText={'Previously recommended products'}
          image={product.image}
          productLink={product.productLink}
          description={product.description}
          price={getProductPrice(product)}
          title={product.title}
        />
      ))}
    </>
  );
};

CWHomePage.propTypes = {
  crossSellProducts: PropTypes.arrayOf(
    PropTypes.shape({
      productLink: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  upSellProducts: PropTypes.arrayOf(
    PropTypes.shape({
      productLink: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  globalProducts: PropTypes.arrayOf(
    PropTypes.shape({
      productLink: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  ticketId: PropTypes.string.isRequired,
  setCommerceWizardPath: PropTypes.func.isRequired,
  listType: PropTypes.string,
  previouslyRecommendedProducts: PropTypes.arrayOf(
    PropTypes.shape({
      productLink: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  setCommerceWizardPreviousRecommendation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  crossSellProducts: extract.extractCommerceWizardCrossSellProducts(state),
  upSellProducts: extract.extractCommerceWizardUpsSellProducts(state),
  globalProducts: extract.extractCommerceWizardGlobalProduct(state),
  ticketId: extract.extractSelectedTicketIdFromState(state),
  listType: extract.extractInfoPanelListTypeFromState(state),
  previouslyRecommendedProducts: extract.extractPreviouslyRecommendedProducts(state) || [],
});

const mapDispatchToProps = {
  setCommerceWizardPath: actions.setCommerceWizardPath,
  setCommerceWizardPreviousRecommendation: actions.setCommerceWizardPreviousRecommendation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CWHomePage);
